<template>
  <component
    :is="itemType"
    :touch="'addingPreview'"
    :preloadedItem="preloadedItem"/>
</template>

<script>
import smallTextBox from '@/components/customFields/smallTextBox'
import largeTextBox from '@/components/customFields/largeTextBox'
import roundNumber from '@/components/customFields/roundNumber'
import decimalNumber from '@/components/customFields/decimalNumber'
import phoneNumber from '@/components/customFields/phoneNumber'
import email from '@/components/customFields/email'
import webLink from '@/components/customFields/webLink'
import dateField from '@/components/customFields/dateField'
import checkBox from '@/components/customFields/checkBox'
import dropDown from '@/components/customFields/dropDown'
export default {
  name: 'fieldPreview',
  props: {
    itemType: {
      type: String,
      required: true,
      default: ''
    },
    preloadedItem: {
      type: Object,
      default: () => {
        return {
          name: '',
          placeholder: '',
          defaultValue: null,
          customFieldArrayValues: []
        }
      }
    }
  },
  data: function () {
    return {
    }
  },
  components: {
    smallTextBox,
    largeTextBox,
    roundNumber,
    decimalNumber,
    phoneNumber,
    email,
    webLink,
    dateField,
    checkBox,
    dropDown
  }
}
</script>
